<template>
  <Modal :id="'cmp-main-notice'" @cancelled="onModalCancelled">
    <template slot="body">
      <div v-if="notice" class="notices-container">
        <div class="notice-view" v-html="notice.notice"></div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onOK">OK</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { htmlToString } from "../../../utility";
import { AccountService } from "../../../services/account.service";

export default {
  components: {
    Modal,
  },
  props: {
    notice: {
      type: Object,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    };
  },
  methods: {

    onModalCancelled: function () {
      this.$emit("cancelled", this.notice);
    },
    onOK: async function () {
      const client_notice_id =
       this.notice.client_notice_id;
      const res = await AccountService.updateClientNoticeDisplay(
        client_notice_id
      );
      this.onModalCancelled();
    },
    getNoticeText: function (notice) {
      return htmlToString(notice?.notice) + "...";
    },
    onNoticeItemClick: function (index) {
      this.selectedIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.notices-container {
  display: flex;

  //height: 400px;
  overflow: hidden;
  .notices-list,
  .notice-view {
   // height: 400px;
    overflow: hidden;
  }
  .notices-list {
    min-width: 240px;
    cursor: pointer;

    .notices-item {
      height: 56px;
      &.selected {
        background: #cccccc;
      }
      .dt-list-item--body {
        padding: 5px;
        height: 50px;

        .notice-date {
        }
        .notice-text {
          font-weight: 700;
          max-width: 190px;
        }
      }
    }
  }
  .notice-view {
    background: #fafafa;
  }
}
</style>

<style lang="scss">
.cmp-main-notice {
  width: fit-content;
  position: absolute;
  right: 10px;
  bottom: 10px;
  background: #fafafa !important;
  .dt-modal--options {
    justify-content: center !important;
  }
  .notice-view {
    background: #fafafa;
    div:first-child {
      margin-top: 1rem !important;
    }
    div:first-child>h2:first-child {
      margin-bottom: 1rem !important;
    }
  }
}
</style>